import {initFlexsliderBanner} from '../shared/flexslider-banner';
import {ensureMagnificPopupPlugin, initBannerImagePopup} from '../shared/popups';

export function initGallery() {
    ensureMagnificPopupPlugin();
    initBannerImagePopup();
    initFlexsliderBanner('.flexslider');
    const $ = window.jQuery;
    if ($?.fn.magnificPopup) $('.carousel-gallery-popup').magnificPopup({
        delegate: '.carousel-gallery-link', type: 'image',
        gallery: {enabled: true, navigateByImgClick: true, preload: [0, 1]},
        image: {titleSrc: item => item.el.find('img').attr('alt')},
    });
}
